<!-- <button type="button" class="close" (click)="closeManually()">×</button> -->
<button matIconButton type="button" class="close" (click)="closeManually()"><mat-icon>close</mat-icon></button>

<div class="info-popover-box">
    <p>
        {{data|translate}}
    </p>

</div>